<template>
  <div class="product-table">
    <h2 class="product-table-title">{{ table.title || "Produktauswahl" }}</h2>

    <table class="table is-striped is-narrow">
      <thead>
      <tr>
        <th v-for="(column, key) in table.config" v-if="!column.disabled" :key="key" v-html="column.label"></th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(product, productIndex) in table.data">
        <tr v-for="multiRowIndex in _.get(product, table.multiRowPath, 1)"
            :key="productIndex + '-' + multiRowIndex" :class="multiRowIndex === 1 ? 'parentRow' : 'childRow'">
          <tablefield
            v-for="(column, columnIndex) in table.config"
            :key="productIndex + '-' + multiRowIndex + '-' + columnIndex"
            :column="column"
            :product="product"
            :secondary-index="multiRowIndex - 1"
            :totalWeight="totalWeight"
            :useLegacyFormatting="table.useLegacyFormatting"
          ></tablefield>
        </tr>
      </template>
      </tbody>
    </table>

    <div v-if="showTime" class="fineprint table-time">{{ time }}</div>
  </div>
</template>

<script>
import Tablefield from "../table-field/FieldContainer.vue"
import {Table} from "../../model/table/Table"

export default {
  components: {Tablefield},
  name: 'product-table',
  props: {
    table: {
      type: Table,
      required: true
    },
    showTime: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    time() {
      return this.moment().format('[Stand:] DD. MMMM YYYY, HH:mm [Uhr]')
    },
    totalWeight() {
      return this.table.config.reduce((sum, el) => {
          return sum + (el.weight || 1)
        }
        , 0)
    }

  },
}
</script>



// WEBPACK FOOTER //
// TableOnepagerProducts.vue?e5521b1a